import { render, staticRenderFns } from "./Guia.vue?vue&type=template&id=2c30f3d3&scoped=true&"
import script from "./Guia.vue?vue&type=script&lang=js&"
export * from "./Guia.vue?vue&type=script&lang=js&"
import style0 from "./Guia.vue?vue&type=style&index=0&id=2c30f3d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30f3d3",
  null
  
)

export default component.exports